import { z } from "zod/v4";
import { ChessGameSource } from "./chess-game-model";
import { uuid } from "@banjoanton/utils";

export const ChessGameCollectionSchema = z.object({
    id: z.string(),
    username: z.string(),
    source: z.enum(ChessGameSource),
    dateAdded: z.number(),
    lastSync: z.number().optional(),
    version: z.number().default(1),
});

export type ChessGameCollection = z.infer<typeof ChessGameCollectionSchema>;

type FromProps = {
    id?: string;
    username: string;
    source: ChessGameSource;
    version?: number;
};

const from = (props: FromProps): ChessGameCollection => {
    const now = Date.now();
    return {
        id: props.id ?? uuid(),
        username: props.username,
        source: props.source,
        dateAdded: now,
        lastSync: now,
        version: props.version ?? 1,
    };
};

export const ChessGameCollection = {
    from,
};
